module.exports = __webpack_public_path__ + "static/media/PromoImage_Coins.5cea7374.png";